import $ from 'jquery';

export const getDatasWithOption = (
    jQueryAjaxOptions,
    resolvedCallback,
    rejectedCallback
) => {
    $.ajax(jQueryAjaxOptions)
        .done(resolvedCallback)
        .fail(rejectedCallback);
};
